import React from "react";
import { IconType } from "react-icons";
import { AiFillSetting } from "react-icons/ai";
import { BiGridAlt } from "react-icons/bi";
import { BsTable } from "react-icons/bs";
import { MdPayment } from "react-icons/md";
import { IoIosChatboxes } from "react-icons/io";
import { FaHistory } from "react-icons/fa";

export interface IMenu {
  path: string;
  icon: React.ReactElement<IconType>;
  linkName: string;
  isDisabled?: boolean;
}

export const menuItem = (role: string) => {
  return [
    {
      path: "/",
      icon: <BiGridAlt size="20px" />,
      linkName: "หน้าแรก",
      isDisabled: !(role === "admin" || role === "doctor"),
    },
    {
      path: "/manage",
      icon: <BsTable size="20px" />,
      linkName: "จัดการเวลา",
      isDisabled: !(role === "admin" || role === "doctor"),
    },
    {
      path: "/chat",
      icon: <IoIosChatboxes size="20px" />,
      linkName: "การสนทนา",
      isDisabled: !(role === "admin" || role === "doctor"),
    },
    {
      path: "/payment-customer",
      icon: <MdPayment size="20px" />,
      linkName: "สถานะการจ่ายเงิน",
      isDisabled: !(role === "admin"),
    },
    {
      path: "/history",
      icon: <FaHistory size="20px" />,
      linkName: "ประวัติการรักษา",
      isDisabled: !(role === "admin"),
    },
    {
      path: "/setting",
      icon: <AiFillSetting size="20px" />,
      linkName: "การตั้งค่า",
      isDisabled: !(role === "admin"),
    },
  ];
};
